







import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import json2csv from 'json2csv';
import Utils from '@/modules/Utils';

@Component({})
class ExportEnergy extends Vue {
  @Prop({ default: () => [] }) data;
  @Prop() color;
  @Prop() text;
  @Prop() sourceTitle?: string;


  exportData() {
    const filename = this.sourceTitle + ' - ' + Utils.getDateString();
    let data;
    const newLine = '\r\n';

    data =  this.sourceTitle ? this.sourceTitle + newLine + newLine + json2csv.parse(this.data) : json2csv.parse(this.data);

    if (data) {
      (this.$refs.downloadHelper as HTMLElement).setAttribute(
        'href',
        'data:application/octet-stream;charset=utf-16le;base64,' + btoa(data)
      );
      (this.$refs.downloadHelper as HTMLElement).setAttribute(
        'download',
        filename + '.csv'
      );
      (this.$refs.downloadHelper as HTMLElement).click();
    }
  }
}

export default ExportEnergy;
